import { isKnownMarketoLead } from '@project/shared/utils/tracking/js/tracking';
import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	contactImage: 'js-m-marketo-form__contact-image',
	stateHasImage: 'm-marketo-form__has-contact-image',
	stateAdditionalFieldsVisible: 'm-marketo-form__show-additional-fields',
	rowHide: 'mktoFormRowHide',
	autoSuggestDropdown: 'js-m-marketo-form_product-autosuggest',
	dropdownItem: 'js-m-marketo-form_dropdown-item',
};

interface IProductAutosuggest {
	FieldName: string;
	Endpoint: string;
	BrandLabel: string;
	ProductLabel: string;
	NoResultLabel: string;
	MaxItem: number;
	PermissionQuery: string;
	Language: string;
}

@createModule('MarketoFormGlobal')
export class MarketoFormGlobal extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: () => void) {
		//this is for marketo lightbox not working
		//so changed to when for loaded call this method
		//this.initializeMarketoOnScriptLoad();
		resolve();
	}

	initializeMarketoOnScriptLoad(): void {
		let $this = this;
		let timerRef = setTimeout(() => {
			let MktoForms2 = (window as any)['MktoForms2'];
			if (typeof MktoForms2 != 'undefined') {
				clearTimeout(timerRef);

				MktoForms2.whenReady(function(form: any) {
					let $component = $(form.getFormElem()[0]).closest('div[data-t-name]');

					$this.initMessageBox($component);

					// translate form
					$this.translate(form, $component);

					// sort select options
					$this.sortSelectOptions(form);

					// prefill form based on cookie
					$this.prefillForm(form, $component);

					// message photo
					$this.initContactImage($component);

					// checkbox order
					$this.initCheckboxOrder($component);

					// hide fields
					$this.hideFields($component);

					// to avoid duplicated id in page, update field id to a random id
					// currently we just update the checkbox id
					$this.updateFieldAttributes(form, $component);

					// init product search field
					$this.productAutoSuggest($component);
				});

				MktoForms2.whenRendered(function(form: any) {});
			}
		}, 250);
	}

	// translate field label by field name
	translate(form: any, $component: JQuery<HTMLElement>) {
		let MktoForms2 = (window as any)['MktoForms2'];
		var formEl = form.getFormElem()[0];
		var ANCESTORS_STOR = '.mktoFormRow, .mktoFormCol',
			INPUTS_STOR = 'INPUT, SELECT, TEXTAREA, BUTTON',
			attrTag = 'data-wrapper-for',
			_forEach = Array.prototype.forEach;

		// utility fn: tag outer wrapper DIVs with their inner inputs' names to make them seekable
		(function tagMktoWrappers(formEl) {
			_forEach.call(formEl.querySelectorAll(ANCESTORS_STOR), function(ancestor: any) {
				ancestor.setAttribute(attrTag, '');
				_forEach.call(ancestor.querySelectorAll(INPUTS_STOR), function(input: any) {
					var currentTag = ancestor.getAttribute(attrTag);
					ancestor.setAttribute(attrTag, [currentTag ? currentTag : '', input.name].join(' ').trim());
				});
			});
		})(formEl);

		let translateMapEl = $component.find(`[data-map-id="translateMap"]`); // get translations embedded in form rich text area

		let jsonStr = translateMapEl.text();

		if (jsonStr.length > 0) {
			let translateMap = JSON.parse(jsonStr);
			let currentTranslations = translateMap;

			// loop over translatables
			var fieldName, fieldTranslations, propertyName, propertyValue: any, translateTargetEl: any;
			for (fieldName in currentTranslations) {
				fieldTranslations = currentTranslations[fieldName];
				for (propertyName in fieldTranslations) {
					propertyValue = fieldTranslations[propertyName];
					switch (propertyName) {
						case 'label':
							translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"] LABEL');
							if (translateTargetEl != null) {
								translateTargetEl.lastChild.nodeValue = propertyValue;
							}
							break;

						case 'validation':
							translateTargetEl = MktoForms2.$(
								formEl.querySelector('[data-wrapper-for="' + fieldName + '"] .mktoFieldDescriptor')
							);
							if (translateTargetEl != null) {
								let mktoFieldDescriptor = translateTargetEl.data('mktoFieldDescriptor');
								if (mktoFieldDescriptor != undefined) {
									mktoFieldDescriptor.validationMessage = propertyValue;
								}
							}
							break;

						case 'placeholder':
							translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"] INPUT');
							if (translateTargetEl != null) {
								translateTargetEl.setAttribute('placeholder', propertyValue);
							}
							break;

						case 'submit':
							translateTargetEl = formEl.querySelector('BUTTON[type="submit"]');
							if (translateTargetEl != null) {
								translateTargetEl.innerHTML = propertyValue;
							}
							break;

						case 'html':
							translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"]');
							if (translateTargetEl != null) {
								translateTargetEl.innerHTML = propertyValue;
							}
							break;

						case 'options':
							translateTargetEl = formEl.querySelectorAll(
								'[data-wrapper-for="' + fieldName + '"] OPTION'
							);
							for (var i = 0; i < translateTargetEl.length; i++) {
								const val = translateTargetEl[i].value;
								const txt = propertyValue[val];
								if (typeof txt !== 'undefined') {
									translateTargetEl[i].text = txt;
								}
							}
							break;

						case 'checkbox':
							translateTargetEl = formEl.querySelector(
								'[data-wrapper-for="' + fieldName + '"] .mktoCheckboxList'
							);
							if (translateTargetEl != null) {
								const labelEle = translateTargetEl.parentElement.querySelector('label');
								labelEle.innerHTML = propertyValue;
							}
							break;

						case 'fieldset':
							translateTargetEl = formEl.querySelector(
								'[data-wrapper-for="' + fieldName + '"] fieldset legend'
							);
							if (translateTargetEl != null) {
								translateTargetEl.innerText = propertyValue;
							}
							break;

						case 'submitprogress':
							translateTargetEl = formEl.querySelector('BUTTON[type="submit"]');
							if (translateTargetEl != null) {
								translateTargetEl.setAttribute('data-submit-progress-text', propertyValue);
								form.onSubmit(function(form: any) {
									if (form.submittable()) {
										translateTargetEl.innerHTML = translateTargetEl.getAttribute(
											'data-submit-progress-text'
										);
									}
								});
							}
							break;
					}
				}
			}
		}
	}

	sortSelectOptions(form: any) {
		let formEl = form.getFormElem()[0];
		let $form = $(formEl);
		const language = $('html').attr('lang');
		const $selectEles = $form.find('select');

		$selectEles.each((i: any, e: any) => {
			let $options = $(e).find('option');
			const $defaultOption = $options.filter("option[value='']");

			// get the "Other" option in dropdown list
			const $othersOption = $options.filter((optIndex: number, optEle: any) => {
				let optValue = $(optEle)
					.val()
					.toString()
					.toLocaleLowerCase();
				let result = optValue == 'others' || optValue == 'other';
				return result;
			});

			const $optionEles = $options.toArray().sort(function(a, b) {
				var aText = $(a).text() as string;
				var bText = $(b).text() as string;
				var result = aText.localeCompare(bText, language, { ignorePunctuation: true });
				return result;
			});

			$(e).empty();

			$(e).append($optionEles);

			// make the "Select..." option at the top
			if ($defaultOption && $defaultOption.length > 0) {
				$(e).prepend($defaultOption);
			}

			// make the "Others" option at the bottom
			if ($othersOption && $othersOption.length > 0) {
				$(e).append($othersOption);
			}

			var id = $(e).attr('id');
			if (id !== 'formVersion' || (id == 'formVersion' && isKnownMarketoLead() == false)) {
				// make sure the first option is selected
				$(e)
					.find('option')
					.first()
					.prop('selected', true);
			}
		});
	}

	formatPhoneNumber(form: any) {
		var vals = form.vals();
		var phone = vals.Phone;
		if (typeof phone !== 'undefined') {
			var formattedPhone = phone.replace(/[^0-9]/g, '').replace(/^0*/g, '');
			form.vals({ Phone: formattedPhone });
		}
	}

	prefillForm(form: any, $component: JQuery<HTMLElement>) {
		let _this = this;

		let prefilledFieldsEle = $component.find("div[data-map-id='prefillFields']");
		let prefilledJsonStr = prefilledFieldsEle.text();

		if (prefilledJsonStr.length > 0) {
			let prefillFields = JSON.parse(prefilledJsonStr);
			let formFieldEles = $component.find('div.mktoFormRow');

			for (var fieldName in prefillFields) {
				let fieldValue: any = prefillFields[fieldName];

				formFieldEles.each(function(i: any, e: any) {
					let $fieldEle = $(e);
					let formFieldId: string = $fieldEle.data('wrapper-for');

					if (fieldName.toLocaleLowerCase() == formFieldId.toLocaleLowerCase()) {
						if (fieldValue != null) {
							let type = $fieldEle.find('input').attr('type');
							if (type == 'checkbox') {
								if (fieldValue == 'true') {
									fieldValue = 'yes';
								}
							}
							let obj = _this.GenerateObject(formFieldId, fieldValue);
							form.vals(obj);
						}
					}
				});
			}
		}
	}

	GenerateObject(formFieldId: string, formFieldValue: string): any {
		let jsonStr = `{"${formFieldId}":"${formFieldValue}"}`;
		let obj = JSON.parse(jsonStr);
		return obj;
	}

	initCheckboxOrder($component: JQuery<HTMLElement>) {
		const $formCheckbox = $component.find('[type="checkbox"]');
		if ($formCheckbox.length > 0) {
			$formCheckbox.parents('.mktoFormRow').css('order', '1');
		}
	}

	initContactImage($component: JQuery<HTMLElement>) {
		const $contactImage = $component.find(`.${classes.contactImage}`);
		const $formMessage = $component.find("textarea[name='formMessage']");
		if ($contactImage.length > 0 && $formMessage.length > 0) {
			$component.addClass(classes.stateHasImage);
		}
	}

	initMessageBox($component: JQuery<HTMLElement>) {
		$component.find("textarea[name='formMessage']").on('focus', (ev: any) => {
			$component.addClass(classes.stateAdditionalFieldsVisible);
		});
	}

	updateFieldAttributes(form: any, $component: JQuery<HTMLElement>) {
		var $formEl = $(form.getFormElem()[0]);
		var rando = new Date().getTime() + parseInt((Math.random() * 1000).toString());

		var $checkboxes = $formEl.find('.mktoField');

		$checkboxes.each((i: any, e: any) => {
			var $chk = $(e);
			var chkId = $chk.attr('id');
			var newChkId = `${chkId}_${rando}`;

			if (chkId != undefined) {
				if (!chkId.includes('_')) {
					// update checkbox id
					$chk.attr('id', newChkId);

					// update label-for attribute
					$chk.parents('.mktoFieldWrap')
						.find(`label[for=${chkId}]`)
						.attr('for', newChkId);
				}
			}
		});

		var formId = $formEl.attr('id');
		var newFormId = `${formId}_${rando}`;
		if (formId != undefined) {
			if (!formId.includes('_', 9)) {
				$formEl.attr('id', newFormId);
			}
		}
	}

	hideFields($component: JQuery<HTMLElement>) {
		let hiddenFieldsStr = $component.find("div[data-map-id='hiddenFields']").text();
		let hiddenFieldsArr = hiddenFieldsStr.split(',');
		let campaignId = $component.data('mktoflow-campaignid');
		let formcampaignId = $component.data('mktoflow-formcampaignid');
		let siteCampaignId = $component.data('mktoflow-sitecampaignid');
		let $formContainer: JQuery<HTMLElement> = $component.find("div[data-id='formContainer']");

		if (campaignId === undefined) {
			campaignId = $formContainer.data('mktoflow-campaignid');
		}
		if (formcampaignId === undefined) {
			formcampaignId = $formContainer.data('mktoflow-formcampaignid');
		}
		if (siteCampaignId === undefined) {
			siteCampaignId = $formContainer.data('mktoflow-sitecampaignid');
		}

		let formFieldEles = $component.find('div.mktoFormRow');
		for (var field in hiddenFieldsArr) {
			let fieldName = hiddenFieldsArr[field];

			formFieldEles.each(function(i: any, e: any) {
				let $fieldEle = $(e);
				let formFieldId: string = $fieldEle.data('wrapper-for');

				if (fieldName.toLocaleLowerCase() == formFieldId.toLocaleLowerCase()) {
					$fieldEle.addClass(classes.rowHide);
				}
			});
		}

		formFieldEles.each(function(i: any, e: any) {
			let $fieldEle = $(e);
			let formFieldId: string = $fieldEle.data('wrapper-for');

			if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden') {
				$fieldEle.addClass(classes.rowHide);
			}

			if (formFieldId == '') {
				if ($fieldEle.find('div.mktoHtmlText').length === 0) {
					$fieldEle.addClass(classes.rowHide);
				} else {
					$fieldEle.removeClass(classes.rowHide);
				}
			}

			if (
				$fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
				$fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'tempPreferenceIndustry'
			) {
				$fieldEle.find('input[name="' + formFieldId + '"]').val($('#frmPageIndustrytags').val());
			}

			if (
				$fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
				$fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'tempPreferenceMaterial'
			) {
				$fieldEle.find('input[name="' + formFieldId + '"]').val($('#frmPageMaterialtags').val());
			}

			if (
				$fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
				$fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'tempPreferenceTheme'
			) {
				$fieldEle.find('input[name="' + formFieldId + '"]').val($('#frmPagePreferenceTheme').val());
			}

			var urlParams = new URLSearchParams(window.location.search);
			var utmId = '';
			if (urlParams.has('utm_id')) {
				utmId = urlParams.get('utm_id');
			}
			if (typeof utmId === 'string' && utmId.length === 0) {
				if (typeof campaignId === 'undefined') {
					if (typeof formcampaignId === 'undefined') {
						if (
							$fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
							$fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'mktoCampaignID'
						) {
							$fieldEle.find('input[name="' + formFieldId + '"]').val(siteCampaignId);
						}
					} else {
						if (
							$fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
							$fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'mktoCampaignID'
						) {
							$fieldEle.find('input[name="' + formFieldId + '"]').val(formcampaignId);
						}
					}
				} else {
					if (
						$fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
						$fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'mktoCampaignID'
					) {
						$fieldEle.find('input[name="' + formFieldId + '"]').val(campaignId);
					}
				}
			} else {
				if (
					$fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
					$fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'mktoCampaignID'
				) {
					$fieldEle.find('input[name="' + formFieldId + '"]').val(utmId);
				}
			}
		});
	}

	productAutoSuggest($component: JQuery<HTMLElement>) {
		let _this = this;

		let autosuggestObjJsonStr = $component.find("div[data-map-id='autosuggestObj']").text();

		if (autosuggestObjJsonStr.length > 0) {
			let autoObj: IProductAutosuggest = JSON.parse(autosuggestObjJsonStr);

			if (autoObj.FieldName && autoObj.FieldName.length > 0) {
				let $autoEle = $component.find(`.${classes.autoSuggestDropdown}`);

				// disable browser's autocomplete feature
				$component.find(`input[name='${autoObj.FieldName}']`).on('focus', function(ev: any) {
					$(ev.currentTarget).attr('autocomplete', 'off');
				});

				$component.find(`input[name='${autoObj.FieldName}']`).on('input propertychange', function(ev: any) {
					let $target: any = $(ev.currentTarget);
					$target.attr('data-t-uvpno', '');
					$target.addClass('js-m-mkto-form-productname', '');
					let val = $target.val();

					if (val.length >= 2) {
						$.ajax({
							type: 'GET',
							url: autoObj.Endpoint,
							dataType: 'json',
							data: {
								term: val,
								permissionQuery: autoObj.PermissionQuery,
								max: autoObj.MaxItem,
								lang: autoObj.Language,
							},
							success: (response: any) => {
								if (response) {
									// clear dropdown
									$autoEle.empty();

									// render brand dropdown items
									//_this.renderDropdown($autoEle, response.suggestions, autoObj.BrandLabel);

									// render product dropdown items
									_this.renderDropdown($autoEle, response.productSuggestions, autoObj.ProductLabel);

									// rebind dropdown items event
									if ($autoEle.children().length > 0) {
										_this.rebindDropdownEvents($component, autoObj.FieldName);
									}

									// render no result found label
									else {
										let labelContent = _this.generateDropdownLabelContent(
											val,
											autoObj.NoResultLabel
										);
										$autoEle.append(labelContent);
									}

									_this.showDropdown($autoEle, $target);
								}
							},
							complete: () => {},
							error: (xhr: any, status: string, error: string) => {
								console.log(
									`marketo form, get product auto-suggest data error, ${xhr.status}, ${
										xhr.statusText
									}, ${error}`
								);
							},
						});
					} else {
						$autoEle.removeAttr('style');
					}
				});

				_this.resizeDropdown($component, autoObj.FieldName);

				_this.autoHideDropdown($component, autoObj.FieldName);
			}
		}
	}

	generateDropdownItemContent(text: string, uvptext: string) {
		let htmlContent = `<li class="m-marketo-form__filter-dropdown-item ${
			classes.dropdownItem
		}" data-t-uvp=${uvptext}>${text}</li>`;
		return htmlContent;
	}

	generateDropdownLabelContent(text: string, NoResultLabel: string = '') {
		if (text == 'Product') {
			let htmlContent = `<li class="m-marketo-form__filter-dropdown-item m-marketo-form__filter-dropdown-item--label js-m-marketo-form_dropdown-label">${text}</li>`;
			return htmlContent;
		} else {
			let htmlContent = `<li class="m-marketo-form__filter-dropdown-item m-marketo-form__filter-dropdown-item--label js-m-marketo-form_dropdown-label m-marketo-form__noresult"> ${NoResultLabel} <b>${text}</b></li>`;
			return htmlContent;
		}
	}

	resizeDropdown($component: JQuery<HTMLElement>, fieldName: string) {
		$(window).on('resize', () => {
			const $target: any = $component.find(`input[name='${fieldName}']`);
			if ($target.length > 0) {
				const currentTop = $target.closest('.mktoFormRow').position().top + $target.outerHeight();
				const currentLeft = $target.closest('.mktoFormRow').position().left;
				const currentWidth = $target.outerWidth();

				$component.find(`.${classes.autoSuggestDropdown}`).css({
					top: `${currentTop}px`,
					left: `${currentLeft}px`,
					width: `${currentWidth}px`,
				});
			}
		});
	}

	renderDropdown($autoEle: JQuery<HTMLElement>, data: any, label: string) {
		if (data && data.length > 0) {
			let labelContent = this.generateDropdownLabelContent(label);
			$autoEle.append(labelContent);

			data.forEach((d: any) => {
				let htmlContent = this.generateDropdownItemContent(d.value, d.uvp);
				$autoEle.append(htmlContent);
			});
		}
	}

	rebindDropdownEvents($component: JQuery<HTMLElement>, fieldName: string) {
		let _this = this;
		$component.find(`.${classes.dropdownItem}`).on('click', function(e: any) {
			let $target = $(e.target);
			let value = $target.text();
			let uvpno = $target.attr('data-t-uvp');
			$component.find(`input[name='${fieldName}']`).val(value);
			$component.find(`input[name='${fieldName}']`).attr('data-t-uvpno', uvpno);
			_this.setProductInfo($component, value);
		});
	}

	setProductInfo($component: JQuery<HTMLElement>, value: string) {
		let autosuggestObjJsonStr = $component.find("div[data-map-id='autosuggestObj']").text();
		if (autosuggestObjJsonStr.length > 0) {
			let autoObj: IProductAutosuggest = JSON.parse(autosuggestObjJsonStr);

			$.ajax({
				type: 'GET',
				url: autoObj.Endpoint,
				dataType: 'json',
				data: {
					term: value,
					permissionQuery: autoObj.PermissionQuery,
					max: autoObj.MaxItem,
					lang: autoObj.Language,
					extended: 'true',
				},
				success: (response: any) => {
					if (response) {
						if (response.productSuggestions && response.productSuggestions.length > 0) {
							var uvpFieldName = 'productUVP';
							//set hidden productUVP value
							if ($component.attr('data-UvPFieldName').length > 0) {
								uvpFieldName = $component.attr('data-UvPFieldName');
							}

							if ($component.find(`input[name='${uvpFieldName}']`).length > 0) {
								if (response.productSuggestions[0].uvp) {
									$component
										.find(`input[name='${uvpFieldName}']`)
										.val(response.productSuggestions[0].uvp);
								} else {
									$component.find(`input[name='${uvpFieldName}']`).val('');
								}
							}

							//set hidden inferredProductBrandInterest value
							var brandFieldName = 'inferredProductBrandInterest';
							if ($component.attr('data-BrandFieldName').length > 0) {
								brandFieldName = $component.attr('data-BrandFieldName');
							}

							if ($component.find(`input[name='${brandFieldName}']`).length > 0) {
								if (response.productSuggestions[0].brand) {
									$component
										.find(`input[name='${brandFieldName}']`)
										.val(response.productSuggestions[0].brand);
								} else {
									$component.find(`input[name='${brandFieldName}']`).val('');
								}
							}

							//set hidden inferredMaterialInterest value
							var materialFieldName = 'inferredMaterialInterest';
							if ($component.attr('data-MaterialFieldName').length > 0) {
								materialFieldName = $component.attr('data-MaterialFieldName');
							}

							if ($component.find(`input[name='${materialFieldName}']`).length > 0) {
								if (
									response.productSuggestions[0].materials &&
									response.productSuggestions[0].materials.length > 0
								) {
									var value = '';
									if (response.productSuggestions[0].materials.length == 1) {
										value = response.productSuggestions[0].materials[0];
									} else {
										response.productSuggestions[0].materials.forEach((d: any) => {
											value = value + d + '; ';
										});
									}
									$component.find(`input[name='${materialFieldName}']`).val(value);
								} else {
									$component.find(`input[name='${materialFieldName}']`).val('');
								}
							}

							//set hidden inferredApplicationInterest value
							var applicationFieldName = 'inferredApplicationInterest';
							if ($component.attr('data-ApplicationFieldName').length > 0) {
								applicationFieldName = $component.attr('data-ApplicationFieldName');
							}
							if ($component.find(`input[name='${applicationFieldName}']`).length > 0) {
								if (
									response.productSuggestions[0].applications &&
									response.productSuggestions[0].applications.length > 0
								) {
									var value = '';
									if (response.productSuggestions[0].applications.length == 1) {
										value = response.productSuggestions[0].applications[0];
									} else {
										response.productSuggestions[0].applications.forEach((d: any) => {
											value = value + d + '; ';
										});
									}

									$component.find(`input[name='${applicationFieldName}']`).val(value);
								} else {
									$component.find(`input[name='${applicationFieldName}']`).val('');
								}
							}

							//set hidden inferredIndustryInterest value
							var industryFieldName = 'inferredIndustryInterest';
							if ($component.attr('data-IndustryFieldName').length > 0) {
								industryFieldName = $component.attr('data-IndustryFieldName');
							}
							if ($component.find(`input[name='${industryFieldName}']`).length > 0) {
								if (
									response.productSuggestions[0].industries &&
									response.productSuggestions[0].industries.length > 0
								) {
									var value = '';
									if (response.productSuggestions[0].industries.length == 1) {
										value = response.productSuggestions[0].industries[0];
									} else {
										response.productSuggestions[0].industries.forEach((d: any) => {
											value = value + d + '; ';
										});
									}

									$component.find(`input[name='${industryFieldName}']`).val(value);
								} else {
									$component.find(`input[name='${industryFieldName}']`).val('');
								}
							}

							//set hidden inferredBUInterest value
							var businessUnitFieldName = 'inferredBUInterest';
							if ($component.attr('data-BusinessUnitFieldName').length > 0) {
								businessUnitFieldName = $component.attr('data-BusinessUnitFieldName');
							}
							if ($component.find(`input[name='${businessUnitFieldName}']`).length > 0) {
								if (
									response.productSuggestions[0].businessUnits &&
									response.productSuggestions[0].businessUnits.length > 0
								) {
									var value = '';
									if ((response.productSuggestions[0].businessUnits.length = 1)) {
										value = response.productSuggestions[0].businessUnits[0];
									} else {
										response.productSuggestions[0].businessUnits.forEach((d: any) => {
											value = value + d + '; ';
										});
									}

									$component.find(`input[name='${businessUnitFieldName}']`).val(value);
								} else {
									$component.find(`input[name='${businessUnitFieldName}']`).val('');
								}
							}

							//set hidden BusinessEntity value
							var businessEntityFieldName = 'mktoBusinessEntity';
							if ($component.attr('data-BusinessUnitFieldName').length > 0) {
								businessEntityFieldName = $component.attr('data-BusinessUnitFieldName');
							}
							if ($component.find(`input[name='${businessEntityFieldName}']`).length > 0) {
								if (
									response.productSuggestions[0].businessEntity &&
									response.productSuggestions[0].businessEntity.length > 0
								) {
									let value: any = response.productSuggestions[0].businessEntity;
									$component.find(`input[name='${businessEntityFieldName}']`).val(value);
								} else {
									$component.find(`input[name='${businessEntityFieldName}']`).val('');
								}
							}
						}
					}
				},
				complete: () => {},
				error: (xhr: any, status: string, error: string) => {
					console.log(
						`marketo form, get product auto-suggest data error, ${xhr.status}, ${xhr.statusText}, ${error}`
					);
				},
			});
		}
	}

	showDropdown($autoEle: JQuery<HTMLElement>, $fieldEle: JQuery) {
		const currentTop = $fieldEle.closest('.mktoFormRow').position().top + $fieldEle.outerHeight();
		const currentLeft = $fieldEle.closest('.mktoFormRow').position().left;
		const currentWidth = $fieldEle.outerWidth();

		$autoEle.css({
			top: `${currentTop}px`,
			left: `${currentLeft}px`,
			width: `${currentWidth}px`,
		});
		$autoEle.show();
	}

	autoHideDropdown($component: JQuery<HTMLElement>, fieldName: string) {
		$component.find(`input[name='${fieldName}']`).on('click', function(ev: any) {
			ev.stopPropagation();
		});

		$('body').on('click', () => {
			$component.find(`.${classes.autoSuggestDropdown}`).removeAttr('style');
			let uvpno = $component.find('.js-m-mkto-form-productname').attr('data-t-uvpno');
			if (uvpno === undefined || uvpno === '') {
				$component.find('.js-m-mkto-form-productname').val('');
			}
		});
	}

	stop() {}
}
